<div mat-dialog-title>
  <app-dialog-close-cross></app-dialog-close-cross>
  <h2>{{ 'APPLICATIONS.BTNS.IMPORT' | translate }}</h2>
</div>

<div mat-dialog-content>
  <form>
    <mat-form-field class="form-field-maxi">
      <mat-label>{{ 'APPLICATIONS.VERSION' | translate }}</mat-label>
      <mat-select [(ngModel)]="version" [ngModelOptions]="{ standalone: true }">
        <mat-option *ngFor="let conf of list" [value]="conf.version">
          {{ conf.version }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="alert alert-info">{{ 'APPLICATIONS.IMPORT_WARNING' | translate }}</div>
  </form>
</div>

<div mat-dialog-actions>
  <button class="space-h-s btn-warn" mat-raised-button (click)="cancel()">{{ 'CANCEL' | translate }}</button>
  <button class="space-h-s btn-submit" mat-raised-button (click)="submitSelection()">{{ 'CONFIRM' | translate }}</button>
</div>
